module.exports = __webpack_public_path__ + "static/media/daycartLogo.b55b2f2c.svg";